import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormSectionComponent } from './form-section.component';

@NgModule({
  imports: [CommonModule],
  exports: [FormSectionComponent],
  declarations: [FormSectionComponent],
  providers: [],
})
export class FormSectionComponentModule {}
